import { render } from "./BallDetail.vue?vue&type=template&id=27483154&scoped=true&ts=true"
import script from "./BallDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./BallDetail.vue?vue&type=script&setup=true&lang=ts"

import "./BallDetail.vue?vue&type=style&index=0&id=27483154&scoped=true&lang=scss"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27483154"],['__file',"src/views/home/BallDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27483154"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27483154', __exports__)) {
    console.log('reload')
    api.reload('27483154', __exports__)
  }
  
  module.hot.accept("./BallDetail.vue?vue&type=template&id=27483154&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('27483154', render)
  })

}


export default __exports__